<template>
    <div class="bg">
        <div class="content">
<!--            <IndexIntro v-if="index==1"></IndexIntro>-->
<!--            <IndexPos v-else></IndexPos>-->
<!--                <index-pos></index-pos>-->

            <div class="pos_bg">
                <div class="icon_wrap">
                    <img src="https://umed.oss-cn-hangzhou.aliyuncs.com/say/icon.png">
                </div>
                <div class="info_wrap">
                    <div class="item">
                        <span>{{txt_info.name}}</span>
                        <input type="text" v-model="info.name">
                        <span></span>
                    </div>
                    <div class="item">
                        <span>{{txt_info.dept}}</span>
                        <input type="text" v-model="info.dept">
                        <span></span>
                    </div>
                    <div class="item">
                        <span>{{txt_info.slogan}}</span>
                        <input type="text" v-model="info.slogan" maxlength="28">
                        <span></span>
                    </div>
                    <div class="txt-item">
                        <span>{{txt_info.hint1}}</span>
                    </div>
                    <div class="item">
                        <span>{{txt_info.avatar}}</span>
                        <input type="text" readonly>
                        <div class="plus_wrap" >
                            <label class="plus" @click="imgClick" >+</label>
                        </div>
                        <div style="display: none">
                            <input id="fileElem" type="file" accept="image/jpeg,image/jpg,image/png"  @change="imgChange"  ref="imgRef"/>
                        </div>
                    </div>
                    <div class="imgShowWrap" v-if="avatar_url!=''">
                        <img id="imgShow" :src="avatar_url">
                    </div>
                    <div class="item">
                        <span>{{txt_info.video}}</span>
                        <input type="text" readonly id="videoPicker">
                        <div class="plus_wrap">
                            <label class="plus" @click="videoClick">+</label>
                        </div>
                        <div style="display: none">
                            <input id="videoElem" type="file"  accept="video/*" @change="videoChange" ref="videoRef">
                        </div>
                    </div>
                    <div class="videoShowWrap" v-if="video_url!=''">
                        <video id="videoShow"  :src="video_url" controls="controls" x5-playsinline="" playsinline="" webkit-playsinline preload="auto" ></video>
                    </div>
                    <!--            <div class="txt-item">-->
                    <!--                <span>{{txt_info.hint2}}</span>-->
                    <!--                <label>{{txt_info.hint3}}</label>-->
                    <!--            </div>-->
                </div>

                <div class="agree">
                    <input type="checkbox" class="checkBox" v-model="agreeTag">
<!--                    <span  class="c" @click="agreeTag=!agreeTag" :class="agreeTag?'uncheck':'check'"></span>-->
                    <label  @click="agreeTag=!agreeTag">我已阅读并同意</label>
                    <label style="color: #2ba6bb;margin-right: 10px" @click="toAgree">{{info_agree}}</label>
                </div>

                <div class="submit_wrap" @click="toPoster">
                    <span>{{txt_info.submit}}</span>
                </div>

                <div class="kv_wrap">
                    <img src="https://umed.oss-cn-hangzhou.aliyuncs.com/say/kv.png" alt="kv">
                </div>


            </div>



        </div>
<!--        <div class="bottom">-->
<!--            <span :class="index==1?'light':''" @click="index=1">{{btn1}}</span>-->
<!--            <span :class="index!=1?'light':''" @click="index=2">{{btn2}}</span>-->
<!--        </div>-->

    </div>
</template>

<script>
    // import IndexIntro from './IndexIntro'
    // import IndexPos from './IndexPos'
    import {openId} from "@/assets/js/api";
    import {ossUpload} from '@/assets/util/util'
    import { Indicator,MessageBox} from "mint-ui";
    import {addSayInfo,getSayInfo} from "@/assets/js/api";
    import {wxShare} from "@/assets/js/api";
    import wx from "weixin-jsapi";


    export default {
        name: "index",
        components:{
            // IndexIntro,
            // IndexPos
        },
        data(){
            return{
                msg:"msg",
                btn1:"项目介绍",
                btn2:"倡议海报",
                // openid:localStorage.getItem("openid"),
                code:this.$route.query.code,
                agreeTag:false,
                info_agree:"《知情同意授权书》",
                txt_info:{
                    name:"姓名*:",
                    dept:"单位*:",
                    slogan:"倡议口号*:",
                    avatar:"照片*:",
                    video:"倡议视频:",
                    hint1:"口号最多不超过28个字，如：降压达标将高血压患者的心血管风险降到最低，最大获益",
                    hint2:"倡议口号",
                    hint3:"关注10.8 全国高血压日为爱发声 、测量血压、坚持服药：",
                    submit:"生成海报",
                },
                imgThumbnail:false,
                videoThumbnail:false,
                info:{
                    openid:localStorage.getItem("openid"),
                    name:"",
                    dept:"",
                    slogan:"",
                    avatar:"",
                    video:""
                },
                avatar_url:"",
                video_url:"",
                link: location.href.split("#")[0],
                title: '关注10月8日全国高血压日',
                desc: "#为爱发声 #测量血压 #坚持服药",
                imgUrl:"https://umed.oss-cn-hangzhou.aliyuncs.com/say/forlove.jpg",


            }
        },
        methods:{
            async getOpenId(code){
                const res = await openId({code})
                if(res.data.success){
                    this.info.openid = res.data.openId
                    localStorage.setItem("openid",this.info.openid)
                    this.getSayInfo(this.info.openid)//获取个人信息
                }else{
                    let url = "http://app.iumed.com.cn/say/info"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }
            },
            toAgree(){
                this.$router.push("agree")
            },
            toPoster(){
                if(this.info.name==""){
                    this.$toast("请输入姓名")
                    return
                }
                if(this.info.dept==""){
                    this.$toast("请输入科室")
                    return
                }
                if(this.info.slogan==""){
                    this.$toast("请输入口号")
                    return
                }
                if(this.info.avatar==""){
                    this.$toast("请选择头像")
                    return
                }
                // if(this.info.video==""){
                //     this.$toast("请选择视频")
                //     return
                // }

                console.log(this.agreeTag,"123")

                if(!this.agreeTag){
                    this.$toast("提交前请先阅读知情同意书，并授权同意")
                    return;
                }

                this.addSayInfo(this.info)
            },

            async addSayInfo(info){
                this.showIndicator()
                const res = await addSayInfo({info})
                // console.log(res,"addSayInfo")
                if(res.data.success){
                    this.$router.push({path:"poster",query:{openid:this.info.openid}});
                    // this.$router.push({path:"pdf",query:{url:this.pdfLink}})
                }else{
                    this.$toast(res.data.message)
                }
                this.closeIndicator()
            },

            async getSayInfo(openid){
                const res = await getSayInfo({openid})
                console.log(res,"getInfo")
                if(res.data.success&&res.data.data!=''){
                    this.info = res.data.data
                    this.avatar_url = this.info.avatar
                    this.video_url = this.info.video
                }
            },

            showIndicator(){
                Indicator.open({
                    text: "上传中",
                    spinnerType: "fading-circle",
                });
            },
            closeIndicator(){
                Indicator.close();
            },

            imgClick(){
                let message = "<div style='background: #eee'><div><span>1:照片需垂直拍照;</span></div> <div><span>2:个人照片占照片整体高度的四分之三以上;</span></div> <div><span>3:照片切勿遮挡，避免强光干扰、光线阴暗等环境;</span></div> <div><span>4:示例如下;</span></div> <div  style='width: 90%; margin: 0 auto'><img style='width: 100%' src='https://umed.oss-cn-hangzhou.aliyuncs.com/say/avatar/boy2.jpg'></div> </div>"
                MessageBox.confirm(message,"照片上传要求").then(action => {
                    if(action == 'confirm') {
                        let ie=navigator.appName=="Microsoft Internet Explorer" ? true : false;
                        if(ie){
                            document.getElementById("fileElem").click();
                        }else{
                            let a=document.createEvent("MouseEvents");
                            a.initEvent("click", true, true);
                            document.getElementById("fileElem").dispatchEvent(a);

                        }
                    }}
                );
            },

            videoClick(){
                let ie=navigator.appName=="Microsoft Internet Explorer" ? true : false;
                if(ie){
                    document.getElementById("videoElem").click();
                }else{
                    let a=document.createEvent("MouseEvents");
                    a.initEvent("click", true, true);
                    document.getElementById("videoElem").dispatchEvent(a);
                }
            },

            imgChange(event){

                let avatar = event.target.files[0];
                this.avatar_url = URL.createObjectURL(avatar);

                this.showIndicator()
                let _this = this
                let avatarPrefix = "say/avatar/"
                ossUpload(avatar, avatarPrefix).then(function (res) {
                    _this.info.avatar = res
                    _this.closeIndicator();
                });
            },

            videoChange(event){
                let video = event.target.files[0];
                this.video_url= URL.createObjectURL(video);
                this.showIndicator();
                let _this = this
                let videoPrefix = "say/video/"
                ossUpload(video, videoPrefix).then(function (res) {
                    console.log(res,"视频提交结果");
                    _this.info.video = res
                    _this.closeIndicator();
                });
            },

            async weChatShare() {
                let _this = this;
                const url = _this.link;
                const res = await wxShare({ url });
                console.log(_this.link, "link");
                console.log(res.data.data, "wxresult");

                if (res.data.success == true) {
                    wx.config({
                        debug: false, //开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: res.data.data.appId, //必填，公众号的唯一标识
                        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                        signature: res.data.data.signature, // 必填，签名
                        jsApiList: [
                            // "updateAppMessageShareData", //自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0） 新接口
                            // "updateTimelineShareData",//自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0） 老接口
                            "onMenuShareTimeline", //分享到朋友圈 老接口
                            "onMenuShareAppMessage",
                        ], // 必填，需要使用的JS接口列表
                    });

                    wx.ready(function () {
                        //分享给朋友
                        wx.onMenuShareTimeline({
                            title: _this.title,
                            desc: _this.desc,
                            link: _this.link,
                            imgUrl: _this.imgUrl,
                            success: function (res) {
                                console.log(res, "分享成功！");
                            },
                            cancel: function (res) {
                                console.log(res, "分享失败");
                            },
                        });
                        //分享到朋友圈
                        wx.onMenuShareAppMessage({
                            title: _this.title,
                            desc: _this.desc,
                            link: _this.link,
                            imgUrl: _this.imgUrl,
                            success: function (res) {
                                console.log(res, "分享成功");
                            },
                            cancel: function (res) {
                                console.log(res, "分享失败");
                            },
                        });
                    });
                }
            },
        },
        created(){
            this.weChatShare()
        },
        mounted() {
            if(this.info.openid==null){
                if(this.code!=null){
                    this.getOpenId(this.code)
                }else{
                    let url = "http://app.iumed.com.cn/say/info"
                    window.location.replace("http://tang.iumed.com.cn?url="+url)
                }
            }else{
                this.getSayInfo(this.info.openid)
            }

            // if(this.code==null){
            //     let url = "http://app.iumed.com.cn/say/info"
            //     window.location.replace("http://tang.iumed.com.cn?url="+url)
            // }else{
            //     this.getOpenId(this.code)
            // }

        }
    }
</script>

<style scoped lang="scss">
    html,body,.bg{
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
    }

    .bg{
        width: 100%;
        height: 100vh;
        background: #FFF url("https://umed.oss-cn-hangzhou.aliyuncs.com/say/index_bg.png") no-repeat;
        background-size: 100% 100%;
    }

    .content{
        height: 100%;
        overflow: scroll;
    }

    .bottom{
        height: 10%;
        display: flex;
        align-items: center;
        flex-flow: row nowrap;
        justify-content: space-around;
        color: #FFF;
        font-size: 13px;
        span{
            width: 70%;
            background: #1d5688;
            text-align: center;
            border-radius: 5px;
            padding: 5px;
        }
    }

    .light{
        opacity: 0.5;
    }


    .pos_bg{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .icon_wrap{
        padding: 20px;
        img{
            width: 95%;
        }
    }
    .info_wrap{
        width: 75%;
        margin: 0 auto;
        .item{
            border-radius: 15px;
            width: 100%;
            background: #0a4179;
            font-size: 14px;
            color: #FFF;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 10px;
            span{
                margin: 5px 0px 5px 15px;
                text-wrap: normal;
                word-break: normal;
                white-space: nowrap;
            }
            input{
                outline: none;
                border: transparent;
                background: #0a4179;
                color: #FFF;
                font-size: 14px;
                text-indent: 10px;
                flex-grow: 1;
                min-width: 2px;
            }
        }
        .txt-item{
            text-align: left;
            color: #979595;
            font-size: 10px;
            margin: 0 5px 5px 5px;
            span{
                display: block;
            }
        }
    }


    .submit_wrap{
        width: 75%;
        margin: 30px auto;
        border: 2px #1d5688 solid;
        background: #FFF;
        border-radius: 15px;
        font-size: 14px;
        padding: 5px 0;
        font-weight: bold;
    }

    .kv_wrap{
        img{
            width: 80%;
        }
    }

    .plus_wrap{
        position: relative;
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        z-index: 100;
        input[type=file]{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
        }
        .plus{
            font-size: 22px;
        }
    }

    .imgShowWrap{
        width: 90%;
        margin-bottom: 10px;
        img{
            width: 40%;
        }
    }

    .videoShowWrap{
        width: 80%;
        margin: 0 auto;
    }

    #videoShow{
        width: 90%;
    }

    .agree{
        width: 100%;
        text-align: right;
        font-size: 13px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        padding-top: 20px;
        .c{
            display: inline-block;
            margin: 0px 5px 0px 0;
        }

        .check{
            width: 16px;
            height: 16px;
            background: transparent url("https://umed.oss-cn-hangzhou.aliyuncs.com/say/check.png") no-repeat;
            background-size: 100% 100%;
        }
        .uncheck{
            width: 16px;
            height: 16px;
            background: transparent url("https://umed.oss-cn-hangzhou.aliyuncs.com/say/uncheck_1.png") no-repeat;
            background-size: 100% 100%;
        }
    }

    .checkBox{
        width: 16px;
        height: 16px;
    }


</style>
